export const MEDIA_FRAGMENT = `
  fragment MediaFragment on Media {
    uri
    source
  }`;
